import type { ComponentProps } from 'react'
import { CalendarClock, SlidersVertical } from 'lucide-react'
import type { WebModule } from '../core/index.js'
import { ScoringRunsPage } from './admin/ScoringRunsPage.js'
import { ScoreSimulatorPage } from './score-simulator/ScoreSimulatorPage.js'
import { SCORING_HELP_TOPICS } from './help.js'

type Api = ComponentProps<typeof ScoreSimulatorPage>['api'] & ComponentProps<typeof ScoringRunsPage>['api']

/** What the scoring module contributes to the shells: the Score Simulator and the scheduler's runs. */
export const scoringWebModule: WebModule<Api> = {
  name: 'scoring',
  adminPages: [
    { path: '/admin/score-simulator', label: 'Score Simulator', title: 'Score Engine Simulator', icon: SlidersVertical, group: 'scoring', page: ({ api }) => <ScoreSimulatorPage api={api} /> },
    { path: '/admin/scoring-runs', label: 'Scheduled Runs', title: 'Scoring Engine Runs', icon: CalendarClock, group: 'scoring', page: ({ api }) => <ScoringRunsPage api={api} /> },
  ],
  helpTopics: SCORING_HELP_TOPICS,
}
